import { render, staticRenderFns } from "./DeleteConfirmQuestion.vue?vue&type=template&id=1fdfcf9a"
import script from "./DeleteConfirmQuestion.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports